export default {"src":"/_next/static/media/Empoli.52275191.svg","height":250,"width":213,"blurWidth":0,"blurHeight":0};